import { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';
import get from 'lodash/get';

const DEFAULT_FILE_NAME = 'export.xlsx';

// content-disposition is absent whenever the API omits it or - cross-origin - does not list it in
// Access-Control-Expose-Headers, and it is always absent in mock mode. Reading it unguarded threw.
const getFileName = (
  responseHeaders: AxiosResponseHeaders | RawAxiosResponseHeaders,
  fallbackFileName: string
) => {
  const header = get(responseHeaders, 'content-disposition');

  if (typeof header !== 'string' || !header.includes('"')) {
    return fallbackFileName;
  }

  return header.slice(header.indexOf('"') + 1, header.lastIndexOf('"')) || fallbackFileName;
};

export const exportFile = async (
  data?: {
    response: BlobPart;
    responseHeaders: AxiosResponseHeaders | RawAxiosResponseHeaders;
  },
  fallbackFileName: string = DEFAULT_FILE_NAME
) => {
  if (data) {
    const blob = new Blob([data.response]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', getFileName(data.responseHeaders, fallbackFileName));
    document.body.appendChild(link);
    link.click();
  }
};
